// Full-screen warning shown 30 seconds before an idle-timeout logout.
// The user can click "أنا موجود" to reset the session, or wait to be logged out.
import { ShieldAlert, Clock } from "lucide-react";

export default function IdleWarningOverlay({ secondsLeft, onStay }) {
  if (!secondsLeft || secondsLeft <= 0) return null;
  return (
    <div className="fixed inset-0 z-[9999] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4"
         data-testid="idle-warning-overlay">
      <div className="bg-white rounded-3xl talabya-shadow-float max-w-md w-full overflow-hidden animate-fade-up">
        <div className="p-5 text-white text-center"
             style={{background: "linear-gradient(135deg, #C2410C 0%, #DC2626 100%)"}}>
          <div className="w-16 h-16 rounded-full bg-white/20 flex items-center justify-center mx-auto mb-2">
            <ShieldAlert size={32}/>
          </div>
          <div className="font-black text-xl" style={{fontFamily:"Cairo"}}>هل ما زلت هنا؟</div>
          <div className="text-sm text-white/90 mt-1">
            سيتم تسجيل خروجك تلقائياً للحماية بعد
          </div>
          <div className="mt-3 flex items-center justify-center gap-2">
            <Clock size={20}/>
            <div className="text-5xl font-black tabular-nums" data-testid="idle-warning-countdown">
              {secondsLeft}
            </div>
            <div className="text-lg">ثانية</div>
          </div>
        </div>
        <div className="p-5 space-y-3">
          <button onClick={onStay}
                  className="w-full py-3 rounded-xl bg-primary-brand text-white font-black text-base hover:opacity-90 talabya-shadow-float"
                  data-testid="idle-warning-stay-btn">
            أنا موجود — تابع الجلسة
          </button>
          <p className="text-xs text-[var(--text-secondary)] text-center leading-relaxed">
            نغلق الجلسات الخاملة تلقائياً لحماية حسابك. اضغط الزر أعلاه للمتابعة.
          </p>
        </div>
      </div>
    </div>
  );
}
